/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeObject,
  ApiEnvelopeSurveillanceEventListResponse,
  ApiEnvelopeSurveillanceSessionListResponse,
  SurveillanceGetEventsParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type surveillanceGetSessionsResponse200 = {
  data: ApiEnvelopeSurveillanceSessionListResponse
  status: 200
}

export type surveillanceGetSessionsResponse403 = {
  data: ApiEnvelopeSurveillanceSessionListResponse
  status: 403
}

export type surveillanceGetSessionsResponseSuccess = (surveillanceGetSessionsResponse200) & {
  headers: Headers;
};
export type surveillanceGetSessionsResponseError = (surveillanceGetSessionsResponse403) & {
  headers: Headers;
};

export type surveillanceGetSessionsResponse = (surveillanceGetSessionsResponseSuccess | surveillanceGetSessionsResponseError)

export const getSurveillanceGetSessionsUrl = (botId: string,) => {




  return `/api/Surveillance/${botId}/sessions`
}

export const useSurveillanceGetSessionsHook = (): (botId: string, options?: RequestInit) => Promise<surveillanceGetSessionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSurveillanceGetSessionsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type surveillanceDownloadSessionResponse200 = {
  data: void
  status: 200
}

export type surveillanceDownloadSessionResponseSuccess = (surveillanceDownloadSessionResponse200) & {
  headers: Headers;
};
;

export type surveillanceDownloadSessionResponse = (surveillanceDownloadSessionResponseSuccess)

export const getSurveillanceDownloadSessionUrl = (botId: string,
    sessionId: string,) => {




  return `/api/Surveillance/${botId}/sessions/${sessionId}/download`
}

export const useSurveillanceDownloadSessionHook = (): (botId: string,
    sessionId: string, options?: RequestInit) => Promise<surveillanceDownloadSessionResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sessionId: string, options?: RequestInit) => {

        return customFetcher(getSurveillanceDownloadSessionUrl(botId,sessionId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type surveillanceDeleteSessionResponse200 = {
  data: ApiEnvelopeObject
  status: 200
}

export type surveillanceDeleteSessionResponseSuccess = (surveillanceDeleteSessionResponse200) & {
  headers: Headers;
};
;

export type surveillanceDeleteSessionResponse = (surveillanceDeleteSessionResponseSuccess)

export const getSurveillanceDeleteSessionUrl = (botId: string,
    sessionId: string,) => {




  return `/api/Surveillance/${botId}/sessions/${sessionId}`
}

export const useSurveillanceDeleteSessionHook = (): (botId: string,
    sessionId: string, options?: RequestInit) => Promise<surveillanceDeleteSessionResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sessionId: string, options?: RequestInit) => {

        return customFetcher(getSurveillanceDeleteSessionUrl(botId,sessionId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type surveillanceGetEventsResponse200 = {
  data: ApiEnvelopeSurveillanceEventListResponse
  status: 200
}

export type surveillanceGetEventsResponseSuccess = (surveillanceGetEventsResponse200) & {
  headers: Headers;
};
;

export type surveillanceGetEventsResponse = (surveillanceGetEventsResponseSuccess)

export const getSurveillanceGetEventsUrl = (botId: string,
    params?: SurveillanceGetEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Surveillance/${botId}?${stringifiedParams}` : `/api/Surveillance/${botId}`
}

export const useSurveillanceGetEventsHook = (): (botId: string,
    params?: SurveillanceGetEventsParams, options?: RequestInit) => Promise<surveillanceGetEventsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: SurveillanceGetEventsParams, options?: RequestInit) => {

        return customFetcher(getSurveillanceGetEventsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type surveillanceClearEventsResponse200 = {
  data: ApiEnvelopeObject
  status: 200
}

export type surveillanceClearEventsResponseSuccess = (surveillanceClearEventsResponse200) & {
  headers: Headers;
};
;

export type surveillanceClearEventsResponse = (surveillanceClearEventsResponseSuccess)

export const getSurveillanceClearEventsUrl = (botId: string,) => {




  return `/api/Surveillance/${botId}`
}

export const useSurveillanceClearEventsHook = (): (botId: string, options?: RequestInit) => Promise<surveillanceClearEventsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSurveillanceClearEventsUrl(botId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


